import AASmartSansHeadThin from './fonts/AASmartSansHead-Thin.ttf';
import AASmartSansThin from './fonts/AASmartSans-Thin.ttf';
import AASmartSansLight from './fonts/AASmartSans-Light.ttf';
import AASmartSansRegular from './fonts/AASmartSans-Regular.ttf';
import AASmartSansBold from './fonts/AASmartSans-Bold.ttf';

const aASmartSansHeadThin = {
  fontFamily: 'AASmartSans',
  fontStyle: 'normal',
  fontWeight: 100,
  fontDisplay: 'swap',
  src: `local('AASmartSans-HeadThin'), 
  url(${AASmartSansHeadThin}) format('truetype')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const aASmartSansThin = {
  fontFamily: 'AASmartSans',
  fontStyle: 'normal',
  fontWeight: 200,
  fontDisplay: 'swap',
  src: `local('AASmartSans-Thin'), 
  url(${AASmartSansThin}) format('truetype')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const aASmartSansLight = {
  fontFamily: 'AASmartSans',
  fontStyle: 'normal',
  fontWeight: 300,
  fontDisplay: 'swap',
  src: `local('AASmartSans-Light'), 
  url(${AASmartSansLight}) format('truetype')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const aASmartSansRegular = {
  fontFamily: 'AASmartSans',
  fontStyle: 'normal',
  fontWeight: 400,
  fontDisplay: 'swap',
  src: `local('AASmartSans-Regular'), 
  url(${AASmartSansRegular}) format('truetype')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const aASmartSansBold = {
  fontFamily: 'AASmartSans',
  fontStyle: 'normal',
  fontWeight: 700,
  fontDisplay: 'swap',
  src: `local('AASmartSans-Bold'), 
  url(${AASmartSansBold}) format('truetype')`,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export default [aASmartSansHeadThin, aASmartSansThin, aASmartSansLight, aASmartSansRegular, aASmartSansBold]